import { jsx as _jsx } from "react/jsx-runtime";
import { useFormikContext } from "formik";
import { useIntl } from "react-intl";
import { messages } from "../messages";
import { CircularProgress, Button } from "@material-ui/core";
export const GetContractButton = ({ onGetContract, contractIsLoading, onResetForm }) => {
    const intl = useIntl();
    const { values, isSubmitting, setFieldValue } = useFormikContext();
    const handleClick = () => {
        if (values.registrationNumber.trim()) {
            if (onResetForm) {
                onResetForm();
            }
            setFieldValue("buyoutDate", "");
            setFieldValue("mileage", undefined);
            onGetContract(values.registrationNumber.trim());
        }
    };
    return (_jsx(Button, { variant: "contained", color: "secondary", size: "large", fullWidth: true, onClick: handleClick, disabled: contractIsLoading || isSubmitting || !values.registrationNumber.trim(), children: contractIsLoading ? (_jsx(CircularProgress, { size: 20 })) : (intl.formatMessage(messages.getContract)) }));
};
//# sourceMappingURL=GetContractButton.js.map